// ...new file...
import io from "socket.io-client";

const API_URL = process.env.REACT_APP_API_BASE_URL;

class SocketManager {
  constructor() {
    this.socket = null;
    this.isConnected = false;
  }

  connect() {
    if (!this.socket) {
      this.socket = io(API_URL, {
        autoConnect: true,
        reconnection: true,
        reconnectionDelay: 1000,
        reconnectionAttempts: 5,
      });

      this.socket.on("connect", () => {
        // eslint-disable-next-line no-console
        console.log("Socket connected", this.socket.id);
        this.isConnected = true;
      });

      this.socket.on("disconnect", () => {
        // eslint-disable-next-line no-console
        console.log("Socket disconnected");
        this.isConnected = false;
      });

      this.socket.on("connect_error", (err) => {
        // eslint-disable-next-line no-console
        console.error("Socket connect_error:", err);
      });
    }
    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.isConnected = false;
    }
  }

  emit(event, data) {
    if (this.socket && this.isConnected) {
      this.socket.emit(event, data);
    }
  }

  on(event, callback) {
    if (this.socket) this.socket.on(event, callback);
  }

  off(event, callback) {
    if (this.socket) this.socket.off(event, callback);
  }

  joinUserRoom(userId) {
    if (!userId) return;
    this.emit("join-user-room", userId);
  }
}

export default new SocketManager();
